import React, { useEffect, useRef, useState } from "react";
import { Search } from "lucide-react";

const inputClass =
  "rounded-lg border border-outline bg-surface px-2 py-1.5 text-sm text-text shadow-sm outline-none transition hover:border-info/70 focus:border-info focus:ring-2 focus:ring-info/20";

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
};

export const SearchInput = ({
  value,
  onChange,
  placeholder,
  debounceMs = 300,
}: SearchInputProps) => {
  const [local, setLocal] = useState(value);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    setLocal(value);
  }, [value]);

  const handleChange = (next: string) => {
    setLocal(next);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onChange(next), debounceMs);
  };

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return (
    <div className="relative">
      <Search className="pointer-events-none absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-text-dim" />
      <input
        type="text"
        value={local}
        onChange={e => handleChange(e.target.value)}
        placeholder={placeholder}
        className={`${inputClass} w-56 pl-8`}
      />
    </div>
  );
};
